import { Action, createAction, ThunkAction } from '@reduxjs/toolkit';
import { throttle } from 'lodash-es';
import { requestDataIfNecessary } from 'services/api/api.actions';
import { AppState } from 'store/types';
import { selectCurrentUserBalanceApiConfig } from './user.selectors';

export const updateUserBalanceIfNecessary = createAction(
  'user/UPDATE_BALANCE_IF_NECESSARY',
);

/**
 * Used internally (do not export!!!) to throttle the api calls to
 * `/movimenti-conto-ms/ms/account/movements/getBalance` endpoint.
 */
const requestInboxStatsExecutor = throttle((dispatch, getState) => {
  const apiConfig = selectCurrentUserBalanceApiConfig(getState());
  dispatch(requestDataIfNecessary(apiConfig));
}, 20_000);

/**
 * Creates a thunk action that invokes an update to the user balance,
 * if necessary.
 */
export const requestUserBalanceIfNecessary = (): ThunkAction<
  void,
  AppState,
  void,
  Action
> => {
  return (dispatch, getState) => {
    requestInboxStatsExecutor(dispatch, getState);
  };
};
